export default "__VITE_ASSET__BZjJP6gO__"